import React from 'react';

import RouteSwitch from '@app/routes/RouteSwitch';
import RouteConfigType from '@app/types/RouteConfigType';

// Update the import path to the correct relative location
// Update the import path to the correct relative location and filename
const FileSearchPage = React.lazy(() => import('@pages/FileSearch'));

const fileSearchRoutes: RouteConfigType[] = [
  {
    component: RouteSwitch,
    path: '/file-search',
    title: 'File Search',
    exact: false,
    guard: [],
    useInBreadcrumbs: false,
    routes: [
      {
        component: FileSearchPage,
        path: '/file-search',
        title: 'File Search',
        exact: true,
        guard: [],
        useInBreadcrumbs: false,
      },
    ],
  },
];

export default fileSearchRoutes;
